<template>
  <div class="content-text">
    <h2 class="title-2 text-left">10 Conclusão</h2>

    <p>
      No período de abril de 2024 a maio de 2025,
      <b>{{ nomeMunicipio }}</b
      >, não terá perda de recursos federais no cofinanciamento da APS devido a
      classificação automática <b>“BOM”</b> que recebeu.
    </p>
    <p>
      A avaliação oficial do resultado de desempenho olha para dados
      retroativos, ou seja, quando acontecer em maio de 2025, como está
      prevista, tende a analisar dados a partir de maio de 2024. Isso implica em
      ações imediatas que sejam aderentes ao novo modelo de cofinanciamento
      federal da APS.
    </p>

    <p>
      Entende-se que o valor de
      <b
        >R$
        {{
          diferencaMensalOtimoRegular.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })
        }}
      </b>
      no repasse mensal ou
      <b
        >R$
        {{
          diferencaAnualOtimoRegular.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
          })
        }}
      </b>
      considerando o repasse anual (diferença entre o desempenho
      <b>"ÓTIMO"</b> e <b>"REGULAR"</b>) é representativo para o município
      manter os serviços da APS com qualidade.
    </p>

    <p>
      Para o desempenho <b>"ÓTIMO"</b>, faz-se necessário o trabalho conjunto e
      colaborativo entre a equipe gestora, profissionais de informática,
      monitoramento e avaliação e os profissionais de saúde atuando nas equipes
      (eSF, ACS, eAP, eSB, eMulti) de forma integrada no cuidado continuo aos
      cidadãos do território.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    nomeMunicipio: {
      type: String,
      default: '',
    },
    diferencaMensalOtimoRegular: {
      type: Number,
      default: 0,
    },
    diferencaAnualOtimoRegular: {
      type: Number,
      default: 0,
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss"></style>
